module.exports = __webpack_public_path__ + "assets/img/pages/about/gallery/7.jpg";